import { Component, Input } from '@angular/core';
import { Building } from '../model/building.model';
import { TranslocoDirective } from '@jsverse/transloco';
import { TypologyIndicatorComponent } from '../typology-indicator/typology-indicator.component';
import { BreakAddressPipe } from '../../shared/string.pipe';

@Component({
  selector: 'sibat-building-address',
  templateUrl: `building-address.component.html`,
  styleUrls: ['building-address.component.scss'],
  imports: [TranslocoDirective, TypologyIndicatorComponent, BreakAddressPipe],
})
export class BuildingAddressComponent {
  @Input() building: Building;

  constructor() {}
}
